"use client";

import React from "react";
import "./Payment.css";

import AlfaMallWebPage01 from "../../assets/images/AlfaMallWebPage01_12082020.jpg";
import AlfaMallWebPage02 from "../../assets/images/AlfaMallWebPage02_12082020.jpg";
import AlfaMallWebPage03 from "../../assets/images/AlfaMallWebPage03_12082020.jpg";
import AlfaMallWebPage04 from "../../assets/images/AlfaMallWebPage04_12082020.jpg";
import AlfaMallWebPage05 from "../../assets/images/AlfaMallWebPage05_12082020.jpg";
import AlfaMallWebPage06 from "../../assets/images/AlfaMallWebPage06_12082020.jpg";
import AlfaMallWebPage07 from "../../assets/images/AlfaMallWebPage07_12082020.jpg";
import AlfaMallWebPage08 from "../../assets/images/AlfaMallWebPage08_12082020.jpg";
import { Image } from "antd";

const banners = [
  //   {
  //     id: 1,
  //     imgSrc: AlfaMallWebPage01,
  //     title: "Payment",
  //     description:
  //       "AlfaMall offers several payment methods for Bank Alfalah customers.",
  //   },
  {
    id: 2,
    imgSrc: AlfaMallWebPage02,
    title: "1. Pay by BAF account",
    description: "",
  },
  {
    id: 3,
    imgSrc: AlfaMallWebPage03,
    title: "2. Pay by Alfa Wallet",
    description: "",
  },
  {
    id: 4,
    imgSrc: AlfaMallWebPage04,
    title: "3. Pay using Credit Card",
    description: "",
  },
  {
    id: 5,
    imgSrc: AlfaMallWebPage05,
    title: "4. Pay using Orbit Points",
    description: "",
  },
  {
    id: 6,
    imgSrc: AlfaMallWebPage06,
    title:
      "5. Combination payment – Split the payment between your preferred mode of payment",
    description: "",
  },
  {
    id: 7,
    imgSrc: AlfaMallWebPage07,
    title: "6. SBS Installments or EMI – 0% markup and no processing fee",
    description: "",
  },
  {
    id: 8,
    imgSrc: AlfaMallWebPage08,
    title: "7. EMF",
    description: "",
  },
];

const Page = () => {
  return (
    <div className="payment-banner-container Homepage ">
      {banners.map((banner) => (
        <div className="banner-item" key={banner.id}>
          <h2>{banner.title}</h2>
          <Image
            preview={false}
            src={banner.imgSrc.src}
            alt={banner.title}
            width="100%"
            height="auto"
          />
        </div>
      ))}
    </div>
  );
};

export default Page;
